import { makeStyles } from '@material-ui/core/styles'
import { FONTS, BREAKPOINTS, COLORS } from '../../../constants'

export const styles = makeStyles(theme => ({
  modal: {
    outline: 'none',
    maxWidth: '100%',
    width: '100%',
    margin: '0 auto',
    color: theme.palette.common.black,
    ['& .ReactModal__Overlay']: {
      position: 'absolute',
    },
    [`@media (min-width: ${BREAKPOINTS.mdd}px)`]: {
      maxWidth: 420,
    },
  },
  modalContainer: {
    position: 'relative',
    outline: 'none',
    paddingTop: 40,
    paddingBottom: 60,
    paddingRight: 20,
    paddingLeft: 20,
  },
  closeButton: {
    position: 'absolute',
    top: 18,
    right: 10,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    zIndex: 2,
    outline: 'none',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 500,
    margin: '0 auto',
    paddingBottom: 0,
    position: 'relative',
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      marginTop: 0,
    },
  },
  error: {
    margin: 0,
    color: COLORS.dangerRed,
  },
  passwordField: {
    display: 'flex',
    position: 'relative',
    marginTop: 5,
  },
  passVisibility: {
    position: 'absolute',
    right: '3%',
    top: '35%',
    color: '#5e676f',
    cursor: 'pointer',
    fontSize: 13,
  },
  passwordGuidelines: {
    fontSize: '0.875rem',
    lineHeight: 1.7,
    textAlign: 'center',
    color: COLORS.lightGrey,
    margin: '20px 0 15px 0',
    fontFamily: FONTS.Graphik.GraphikLight,
    letterSpacing: 0.38,
  },
  buttonStyles: {
    fontFamily: FONTS.Graphik.GraphikMedium,
    fontSize: '0.75rem',
  },
  switches: {
    margin: '20px 0 20px 0',
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      marginBottom: '60px',
    },
  },
  termsWrapper: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      margin: 0,
      marginLeft: 15,
      fontSize: '1rem',
      color: theme.palette.common.black,
    },
  },
  switchLabel: {
    fontFamily: FONTS.Graphik.GraphikRegular,
  },
  bold: {
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  modalTitle: {
    marginBottom: 20,
  },
}))
